// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false;

Vue.prototype.$EventBus = new Vue();


/**
 *  # 개발&테스트&운영 모드 분리(API 접속 및 환경설정 분리)
 *  - webpack.prod.conf.js 파일내 환경설정 분기철
 *  - package.json내 "build_prod", "build_test" 추가
 *  - config/test.env.js 파일 추가
 *  - config/prod.env.js, config/test.env.js내에 동일하게 NODE_CDN 변수와 데이터 추가
 *  - src/main.js 내에서 분기처리
 */
// Region Start
let NODE_ENV=process.env.NODE_ENV;
let NODE_REL=process.env.NODE_REL;
let PROJECT_VER= process.env.PROJECT_VER;
window.NODE_ENV = NODE_ENV;
window.NODE_REL = NODE_REL;
window.PROJECT_VER = PROJECT_VER;
switch(NODE_ENV){
  case 'development':{                    // 개발모드(로컬호스트)
      window.API_SERVER_URL = 'http://172.30.1.11:3000/blk-api';
      //window.API_SERVER_URL = 'https://test.ebssw.kr:10543/blk-api';
  }break;
  case 'production':{
      if(NODE_REL === 'pre-release'){     // 테스트모드(네이버클라우드)
          window.API_SERVER_URL = 'https://test.ebssw.kr:10543/blk-api';
      }else if(NODE_REL === 'release'){   // 운영모드(네이버클라우드)
          window.API_SERVER_URL = 'https://www.ebssw.kr/blk-api';
      }else if(NODE_REL === 'staging'){   // 스테이징
        window.API_SERVER_URL = 'https://stg-www.ebssw.kr:10543/blk-api';
    }
  }break;
}
if(NODE_ENV === 'development' || NODE_ENV ==='test'){
    console.log(`[ESOF Codmos]
        NODE_ENV : ${NODE_ENV} | NODE_REL : ${NODE_REL} | ProjectVer : ${PROJECT_VER}
        API_URL : ${window.API_SERVER_URL}
    `);
}

Vue.prototype.API_SERVER_URL = window.API_SERVER_URL;
Vue.prototype.NODE_ENV = window.NODE_ENV;
Vue.prototype.NODE_REL = window.NODE_REL;
Vue.prototype.PROJECT_VER = window.PROJECT_VER;
Vue.prototype.getCookie = function (key) {
  if (typeof key === 'string') {

    let value = ''
    document.cookie.split('; ').forEach(e => {
      if (e.indexOf('=') === -1) return
      e = e.split('=')
      if (e[0] === key) value = e[1]
    })
    return value === '' ? undefined : value
  } else {
    const COOKIE = {}
    document.cookie.split('; ').forEach(e => {
      if (e.indexOf('=') === -1) return
      e = e.split('=')
      COOKIE[e[0]] = e[1]
    })
    return COOKIE
  }
}
Vue.prototype.randomId = function () {
  return (Math.random() * (1 << 30)).toString(16).replace('.', '')
}
const PLUS_ZERO = num => num < 10 ? ('0' + num) : num
Vue.prototype.simpleDateFormat = (date, str = 'yy-MM-dd') => {
  if (typeof date === 'string') date = new Date(date)
  if (date instanceof Date) {
    const YEAR = date.getFullYear()
    const MONTH = (date.getMonth() + 1)
    const DAY = date.getDate()
    const FULL_HOUR = date.getHours()
    const HOUR = (FULL_HOUR % 12) || 12
    const MIN = date.getMinutes()
    const SECOND = date.getSeconds()
    str = str.replace(/YYYY/gi, YEAR)
    str = str.replace(/YY/gi, (YEAR + '').substr(2))
    str = str.replace(/MM/g, PLUS_ZERO(MONTH))
    str = str.replace(/M/g, MONTH)
    str = str.replace(/DD/gi, PLUS_ZERO(DAY))
    str = str.replace(/D/gi, DAY)
    str = str.replace(/W/gi, Math.ceil(DAY / 7))
    str = str.replace(/HH/g, PLUS_ZERO(FULL_HOUR))
    str = str.replace(/H/g, FULL_HOUR)
    str = str.replace(/hh/g, PLUS_ZERO(HOUR))
    str = str.replace(/hh/g, HOUR)
    str = str.replace(/mm/g, PLUS_ZERO(MIN))
    str = str.replace(/m/g, MIN)
    str = str.replace(/SS/gi, PLUS_ZERO(SECOND))
    str = str.replace(/S/gi, SECOND)
    str = str.replace(/MOON/gi, FULL_HOUR > 11 ? 'PM' : 'AM')
    return str
  } else return ''
}
// Region End





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js